import React, { PureComponent } from 'react';
import { getColorPrice } from '../../../helpers/Color';
import { get } from 'lodash';
import { formatDataBidAsk } from '../../../helpers/Common';
import Const from './Const';
import TextBlink from '../../../common/table/TextBlink';
import { formatPrice, formatTextFloat } from '../../../helpers/Text';

class CWBidAsk extends PureComponent {
  render() {
    const { item, itemKey: key, text, realtimeData } = this.props;
    const bidAsk = get(item, key);
    const className = getColorPrice(
      bidAsk,
      get(item, 'referencePrice'),
      get(item, 'ceilingPrice'),
      get(item, 'floorPrice'),
      'text',
    );
    const bidAskVolume =
      Const.index.BEST_1_BID === key
        ? get(item, 'best1BidVolume')
        : get(item, 'best1OfferVolume');
    const bidAskData = formatDataBidAsk(
      bidAsk,
      bidAskVolume,
      get(item, 'tradingDate'),
      false,
      get(item, 'marketStatus'),
      get(item, 'comGroupCode'),
    );

    return (
      <TextBlink
        keyObject={key}
        item={item}
        tradingDate="tradingDate"
        className={className}
      >
        {bidAskData || formatTextFloat(formatPrice(text), 2, true)}
      </TextBlink>
    );
  }
}

CWBidAsk.defaultProps = {};

export default CWBidAsk;
